import { getFAQ } from 'app/shared/components/MarketFAQ';
import type MarketStats from 'app/shared/models/MarketStats';

export function getStructuredData(marketStats: MarketStats) {
    return [
        {
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
                '@context': 'http://schema.org',
                '@type': 'FAQPage',
                mainEntity: getFAQ(marketStats).map((qAndA: { question: string; answer: string }, i) => {
                    const { question, answer } = qAndA;
                    return {
                        '@type': 'Question',
                        name: `${i + 1}. ${question}`,
                        acceptedAnswer: {
                            '@type': 'Answer',
                            text: `<p>${answer}</p>`
                        }
                    };
                })
            })
        }
    ];
}
